/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { Button, FormControl, FormErrorMessage, FormLabel, Input } from '@chakra-ui/react'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import useUploadForm from './useUploadForm'
import FileInfo from '../FileInfo'
import FormWrapper from '@/components/forms/FormWrapper'

const UploadForm = ({ assetsBatch }) => {
  const [hasAlert, setHasAlert] = useState(false)
  const {
    handleSubmit,
    register,
    setError,
    formState: { errors, isSubmitting }
  } = useForm({
    defaultValues: {
      name: assetsBatch?.name
    }
  })
  const {
    fileInfo,
    fileInputRef,
    handleDeleteFile,
    handleOnChange,
    onSubmit,
    uploadDisabled,
    validateCSV
  } = useUploadForm({ assetsBatch, setError, setHasAlert })
  const displayNone = fileInfo
    ? { display: 'none' }
    : {}

  return (
    <FormWrapper hasAlert={hasAlert} >
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControl mb="20px" isInvalid={errors.name}>
          <FormLabel htmlFor="name">Batch name</FormLabel>
          <Input
            id="name"
            {
              ...register('name', {
                required: 'This is required.'
              })
            }
          />
          <FormErrorMessage>
            {errors.name && errors.name.message}
          </FormErrorMessage>
        </FormControl>
        <FormControl>
          <div style={displayNone}>
            <input
              type="file"
              id="avatar"
              accept=".csv,text/csv"
              className="w-full"
              {
                ...register(
                  'csvFile',
                  {
                    onChange: handleOnChange,
                    validate: validateCSV
                  }
                )
              }
              ref={(e) => {
                register('csvFile').ref(e)
                fileInputRef.current = e
              }}
            />
          </div>
          <div className="mb-sm">
            { fileInfo &&
              <FormControl mb="20px" isInvalid={errors.csvFile}>
                <FileInfo
                  fileName={fileInfo.name}
                  deleteFile={handleDeleteFile}
                />
                <FormErrorMessage>
                  { errors?.csvFile && errors?.csvFile.message }
                </FormErrorMessage>
              </FormControl>
            }
          </div>
          <Button
            isLoading={isSubmitting}
            loadingText='Uploading'
            type="submit"
            isDisabled={uploadDisabled}
          >
            + UPLOAD CSV
          </Button>
        </FormControl>
      </form>
    </FormWrapper>
  )
}

export default UploadForm
